import classNames from 'classnames'
import React from 'react'

export const Divider: React.FC<{ className?: string }> = ({ className }) => (
  <hr
    className={classNames('w-full mt-2 mb-4 border-common-gray-4', className)}
  />
)
